export default "/institutions/itau.svg";